<app-layout>
  <div class="reports-admin-page">
    <mat-toolbar class="page-header" role="heading">
      <div class="page-header-title">
        <div class="page-header-copy">
          <span class="eyebrow" appLocalizationPopupDirective localizationCode="Configuration">
            {{ 'Configuration' | translate: {Default: 'Configuration'} }}
          </span>
          <h1 appLocalizationPopupDirective localizationCode="ReportsAdministration">
            {{ 'ReportsAdministration' | translate: {Default: 'Reports Administration'} }}
          </h1>
        </div>
      </div>

      <div class="header-actions">
        <button
          class="back-button"
          mat-stroked-button
          appPreventDoubleClick
          (throttledClick)="goToReports()"
          matTooltip="{{ 'BackToReports' | translate: {Default: 'Back to Reports'} }}"
          appLocalizationPopupDirective
          localizationCode="BackToReports"
        >
          <mat-icon aria-hidden="false" class="material-icons-outlined">arrow_back</mat-icon>
          {{ 'BackToReports' | translate: {Default: 'Back to reports'} }}
        </button>

      </div>
    </mat-toolbar>

    <section class="import-panel">
      <div class="import-card">
        <div class="import-icon">
          <mat-icon aria-hidden="false" class="material-icons-outlined">upload_file</mat-icon>
        </div>

        <div class="import-copy">
          <span class="section-label" appLocalizationPopupDirective localizationCode="Import">
            {{ 'Import' | translate: {Default: 'Import'} }}
          </span>
          <h2 appLocalizationPopupDirective localizationCode="UploadAReportBundle">
            {{ 'UploadAReportBundle' | translate: {Default: 'Upload a report bundle'} }}
          </h2>
          <p appLocalizationPopupDirective localizationCode="ImportReportDescription">
            {{ 'ImportReportDescription' | translate: {Default: 'Import a report definition file to add or update existing report configurations.'} }}
          </p>
        </div>

        <input #importFileInput type="file" accept="application/json,.json" hidden (change)="onImportFileSelected($event)" />

        <button
          setColor="primaryColour"
          class="import-card-button"
          mat-stroked-button
          color="primary"
          appPreventDoubleClick
          (throttledClick)="importFileInput.click()"
          appLocalizationPopupDirective
          localizationCode="ImportReport"
        >
          <mat-icon aria-hidden="false" class="material-icons-outlined">file_upload</mat-icon>
          {{ 'ImportReport' | translate: {Default: 'Import report'} }}
        </button>
      </div>
    </section>

    <div class="grid-shell">
      <app-data-grid-comp
          [columns]="columns"
          [gridDataResult]="gridDataResult"
          [isLoading]="isLoading"
          [pageSize]="pageSize"
          [skip]="skip"
          [sort]="sort"
          [sortableColumns]="sortableColumns"
          [sortable]="{ mode: 'single' }"
          clickableRows="true"
          searchable="true"
          category="Reports"
          [filterCategories]="filterCategories"
          [rowActionButtons]="rowActionButtons"
          (emitPageChangeEvent)="pageChange($event)"
          (emitOpenDialogEvent)="onOpenDialog($event)"
          (emitSearchEvent)="search($event)"
          (emitFilterEvent)="filterCallback($event)"
          (emitSortEvent)="onSort($event)"
          (rowActionEvent)="rowAction($event)"
      ></app-data-grid-comp>
    </div>
  </div>
</app-layout>
